import React, {useState} from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPlus, FiMinus, FiArrowRight} = FiIcons;

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "ฉันไม่มีพื้นฐาน Bazi เลย จะเข้าใจหรือไม่?",
      answer: "ศาสตร์นี้เลือกผู้คน หากคุณรู้สึกถึงแรงดึงดูด แสดงว่าคุณพร้อมแล้ว เราจะนำทางคุณตั้งแต่ก้าวแรก ด้วยวิธีการสอนที่เข้าใจง่าย เชื่อมโยงกับเหตุผลและตรรกะที่คุณคุ้นเคย"
    },
    {
      question: "ศาสตร์ปาจื้อ (八字,Bazi) นี้แตกต่างจากโหราศาสตร์จีนทั่วไปอย่างไร?",
      answer: "ปาจื้อ (八字,Bazi) คือการวิเคราะห์ \"รหัสชีวิต\" เฉพาะบุคคลที่มีความลึกซึ้งและเป็นระบบสูง ไม่ใช่คำทำนายทั่วไป แต่เป็น Framework สำหรับการตัดสินใจเชิงกลยุทธ์ที่อิงบนข้อมูลเฉพาะตัวคุณ"
    },
    {
      question: "ฉันไม่ใช่สายเชื่อ จะได้รับประโยชน์หรือไม่?",
      answer: "ปัญญาไม่ต้องการความเชื่อ มันต้องการเพียงการเปิดใจและการพิสูจน์ด้วยตนเอง ศาสตร์ Bazi ที่เราสอนนั้นตั้งอยู่บนหลักการและเหตุผลที่คุณพิสูจน์ได้ มองเป็นเครื่องมือวิเคราะห์ข้อมูลเชิงสถิติและรูปแบบ"
    },
    {
      question: "การลงทุนนี้จะให้อะไรฉันกลับคืนมา?",
      answer: "ความผิดพลาดเพียงครั้งเดียวในชีวิต อาจมีราคาสูงกว่านี้หลายเท่า ปัญญาจากศาสตร์ Bazi คือ \"เกราะคุ้มกัน\" ที่ประเมินค่าไม่ได้ ที่จะช่วยให้คุณตัดสินใจได้อย่างมั่นใจและแม่นยำยิ่งขึ้น"
    },
    {
      question: "จำเป็นต้องมีเวลาเกิดที่แน่นอนหรือไม่?",
      answer: "เพื่อความแม่นยำสูงสุด การมีเวลาเกิดที่แน่นอนจะช่วยให้การวิเคราะห์ผัง Bazi สมบูรณ์ที่สุด แต่หากไม่มี เราก็มีวิธีการปรับปรุงและประมาณค่าที่ให้ผลลัพธ์ที่น่าเชื่อถือได้"
    },
    {
      question: "หลังจบคอร์สแล้ว จะมีการสนับสนุนต่อเนื่องหรือไม่?",
      answer: "คุณจะได้เข้าร่วมกลุ่มศิษย์เก่าพิเศษ พร้อมการอัพเดทความรู้ใหม่ๆ และโอกาสในการปรึกษาหารือกับเพื่อนร่วมเส้นทาง นอกจากนี้ยังมีหลักสูตรเฉพาะทางเพิ่มเติมสำหรับผู้ที่ต้องการเจาะลึกยิ่งขึ้น"
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 relative" id="faq">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-blue-900/10 to-slate-900"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          <h2 className="text-4xl md:text-5xl font-light text-white mb-8">
            คำชี้แนะสำหรับผู้ที่ยังลังเล
          </h2>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="bg-white/5 backdrop-blur-lg rounded-2xl border border-white/10 overflow-hidden"
              initial={{opacity: 0, y: 20}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.5, delay: index * 0.1}}
              viewport={{once: true}}
            >
              <motion.button
                className="w-full p-8 text-left flex items-center justify-between hover:bg-white/5 transition-colors duration-200"
                onClick={() => toggleFAQ(index)}
                whileHover={{scale: 1.01}}
                whileTap={{scale: 0.99}}
              >
                <h3 className="text-lg font-light text-white pr-4 leading-relaxed">{faq.question}</h3>
                <div className="flex-shrink-0">
                  <SafeIcon icon={openIndex === index ? FiMinus : FiPlus} className="w-6 h-6 text-blue-400" />
                </div>
              </motion.button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{height: 0, opacity: 0}}
                    animate={{height: "auto", opacity: 1}}
                    exit={{height: 0, opacity: 0}}
                    transition={{duration: 0.3}}
                    className="overflow-hidden"
                  >
                    <div className="px-8 pb-8">
                      <p className="text-slate-300 font-light leading-relaxed">{faq.answer}</p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center mt-12"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8, delay: 0.5}}
          viewport={{once: true}}
        >
          <p className="text-slate-400 font-light mb-6">ยังมีข้อสงสัยอื่นๆ อีกไหม?</p>
          <motion.a
            href="https://www.fengshuix.com/event-details/the-bazi-blueprint"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-8 py-3 rounded-2xl font-light hover:shadow-lg transition-all duration-200 inline-flex items-center space-x-2"
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
          >
            <span>ติดต่อสอบถามเพิ่มเติม</span>
            <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;